import { create } from 'zustand';
import { authApi } from '@/lib/api';
import { useDemoStore } from '@/stores/demoStore';
import type { User } from '@/lib/types';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isInitializing: boolean;
  isLoading: boolean;
  setAuth: (user: User) => void;
  checkAuth: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isAuthenticated: false,
  isInitializing: true,
  isLoading: false,

  setAuth: (user) => set({ user, isAuthenticated: true, isInitializing: false, isLoading: false }),

  checkAuth: async () => {
    if (get().isLoading) return;
    if (useDemoStore.getState().isDemoMode) {
      const user = useDemoStore.getState().data?.user ?? null;
      set({ user, isAuthenticated: Boolean(user), isInitializing: false, isLoading: false });
      return;
    }
    set({ isLoading: true });
    try {
      const user = await authApi.me();
      set({ user, isAuthenticated: Boolean(user), isInitializing: false, isLoading: false });
    } catch {
      set({ user: null, isAuthenticated: false, isInitializing: false, isLoading: false });
    }
  },

  logout: async () => {
    if (useDemoStore.getState().isDemoMode) {
      useDemoStore.getState().exitDemo();
      set({ user: null, isAuthenticated: false, isInitializing: false, isLoading: false });
      return;
    }
    try {
      await authApi.logout();
    } finally {
      set({ user: null, isAuthenticated: false, isInitializing: false, isLoading: false });
    }
  },
}));
